export const WIDGET_PRIORITY = {
  DEFAULT: 999,
  HIGH: 1,
  MEDIUM: 500,
  LOW: 999,
} as const;
